<template>
    <div v-if="!loading">
        <div class="header-actions">
            <CorpId />
        </div>

        <p class="mt-0">
            {{
                $l10n.__(
                    "Cette section concerne les utilisateurs, vous retrouvez ici les applications que vous utilisez. Vous pouvez à tout moment interdire l'accès d'une application à votre compte. Une fois l'accès revoqué, ils vous suffira de vous reconnecter à votre compte via l'application pour le restaurer",
                )
            }}
        </p>

        <div class="acenter pb-2">
            <quick-filter :filters="filters" :selected="selected" @selected="filterOn" />
        </div>

        <el-table v-if="appWithStaff.length" :data="appWithStaff" border style="width: 100%">
            <el-table-column prop="consumer_i_app_name" :label="$t.__('common.labels.name')">
                <template #default="scope">
                    <div class="flex-level">
                        <div
                            :class="[
                                'chip',
                                'label-chip',
                                'mr-2',
                                scope.row.token_status == 'enabled'
                                    ? 'chip-primary'
                                    : 'chip-danger',
                            ]"
                        ></div>
                        <div class="flex label-value" v-html="scope.row.consumer_i_app_name"></div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                prop="consumer_i_owner_mail"
                :label="$t.__('developerPage.ThirdPartyApps.developer')"
            >
            </el-table-column>
            <el-table-column prop="user_user_id" :label="$t.__('common.labels.staff')">
                <template #default="scope">
                    <div v-if="scope.row.user_user_type === 'staff'" class="flex-level">
                        <avatar-inline :data="scope.row.staff" />
                    </div>
                </template>
            </el-table-column>
            <el-table-column :label="$t.__('developerPage.ThirdPartyApps.last_connection')">
                <template #default="scope">
                    {{
                        $filters.dateFormatter(scope.row.user_last_login, 'NORMAL_DATE_TIME', false)
                    }}
                </template>
            </el-table-column>
            <el-table-column prop="consumer_i_owner_web" :label="$t.__('common.labels.web_site')">
            </el-table-column>

            <!-- ACTIONS -->
            <el-table-column fixed="right" :label="$t.__('common.labels.actions')" width="200">
                <template #default="scope">
                    <link-button
                        v-if="scope.row.token_status === 'enabled'"
                        class="mr-3"
                        @clicked="deleteApp(scope.row)"
                    >
                        {{ $l10n.__("Désactiver l'accès") }}
                    </link-button>
                </template>
            </el-table-column>
        </el-table>

        <div v-else class="placeholder well">
            <p>
                {{ $l10n.__("Vous n'utilisez aucune application tierce pour le moment") }}
            </p>
        </div>
    </div>

    <preloader v-else :background="false" :display="true" />
</template>

<script>
import Preloader from 'vcomponents/utilities/Preloader.vue';
import LinkButton from 'vcomponents/utilities/LinkButton.vue';
import ChipLabel from 'vcomponents/utilities/ChipLabel.vue';
import AvatarInline from 'vcomponents/utilities/AvatarInline.vue';
import QuickFilter from './QuickFilter.vue';
import CorpId from 'vcomponents/developerPage/CorpId.vue';

export default {
    components: {
        Preloader,
        LinkButton,
        ChipLabel,
        AvatarInline,
        QuickFilter,
        CorpId,
    },
    data() {
        return {
            list: [
                { prop: 'consumer_i_app_name', label: 'Nom' },
                { prop: 'consumer_i_owner_mail', label: 'Développeur' },
                { prop: 'consumer_i_owner_web', label: 'Site Web' },
            ],
            loading: true,
            apps: [],
            filters: [
                {
                    id: 'all',
                    label: this.$l10n.__('Toutes'),
                },
                {
                    id: 'enabled',
                    label: this.$l10n.__('Accès activés'),
                    type: 'primary',
                },
                {
                    id: 'revoked',
                    label: this.$l10n.__('Accès désactivés'),
                    type: 'error',
                },
            ],
            selected: 'all',
        };
    },
    computed: {
        appWithStaff() {
            const apps = this.apps.map((app) => {
                if (app.user_user_type !== 'staff') {
                    return app;
                }

                const staff = {
                    staffid: app.staff.id,
                    status: app.staff.status,
                    type: 'staff',
                    firstname: app.staff.firstname,
                    lastname: app.staff.lastname,
                    fullName: `${app.staff.firstname} ${app.staff.lastname}`,
                    avatar: null,
                };

                if (app.staff.avatar !== null) {
                    staff.avatar = {
                        type: 'picture',
                        value: app.staff.avatar,
                    };
                }
                return {
                    ...app,
                    staff,
                };
            });

            if (this.selected === 'all') {
                return apps;
            }

            return apps.filter((app) => app.token_status === this.selected);
        },
    },
    created() {
        this.getThirdPartyApps()
            .then((apps) => {
                this.apps = apps;
                this.loading = false;
            })
            .catch((error) => {
                Push.error(this.$l10n.__('Une erreur est survenue, merci de réessayer plus tard'));
                this.loading = false;
            });
    },
    methods: {
        getThirdPartyApps() {
            return new Promise((resolve, reject) => {
                this.$ajax.get(
                    `/rest/developer/third-party-apps`,
                    {},
                    (response) => {
                        resolve(response);
                    },
                    (error) => reject(error),
                );
            });
        },
        filterOn(filter) {
            this.selected = filter;
        },
        deleteApp(app) {
            Api.revokeToken(app.token_id, app.token_cid);
        },
    },
};
</script>
<style lang="scss" scoped>
.flex-none {
    flex: none;
}
</style>
